export class FileContentModel {
  fileName: string;
  extension: string;
  encodedBase64: string;
  fileKey?: string;
}